const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="container d-flex flex-column flex-md-row justify-content-between gap-2">
                <span>&copy; 2026 Event Booking</span>
                <span>Black & Pink Edition</span>
            </div>
        </footer>
    );
}

export default Footer;
